import { useEffect, useRef } from 'react';
import { usePlayerV2 } from '../stores/usePlayerV2';

export default function PlayerHostV2() {
  const ref = useRef<HTMLAudioElement | null>(null);
  const attach = usePlayerV2((s) => s.attachElement);

  useEffect(() => {
    if (ref.current) attach(ref.current);
  }, [attach]);

  return (
    <audio
      ref={ref}
      preload="auto"
      playsInline
      style={{ display: 'none' }}
      aria-hidden="true"
    />
  );
}
